import { useSyncExternalStore } from "react";

export interface ToastMessage {
  id: number;
  text: string;
  action?: ToastAction;
}

export interface ToastAction {
  label: string;
  onSelect: () => void;
}

export function showToast(text: string, action?: ToastAction): void {
  current = { id: (current?.id ?? 0) + 1, text, ...(action ? { action } : {}) };
  window.clearTimeout(timer);
  timer = window.setTimeout(dismissToast, action ? ACTION_TOAST_MS : TOAST_MS);
  emit();
}

export function dismissToast(): void {
  window.clearTimeout(timer);
  current = null;
  emit();
}

export function useToastMessage(): ToastMessage | null {
  return useSyncExternalStore(
    subscribe,
    () => current,
    () => null,
  );
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function emit(): void {
  for (const listener of listeners) listener();
}

const TOAST_MS = 1800;
const ACTION_TOAST_MS = 5200;
const listeners = new Set<() => void>();
let current: ToastMessage | null = null;
let timer = 0;
